var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("div", { staticClass: "table-responsive" }, [
      _c("table", { staticClass: "table table-hover" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.nameHeader))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.sizeHeader))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.removeHeader))])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          { attrs: { id: "drop_" + _vm.inputId } },
          [
            !_vm.files.length
              ? _c("tr", { staticClass: "dropField drop-active" }, [
                  _c("td", { attrs: { colspan: "7" } }, [
                    _c("div", { staticClass: "text-center p-5" }, [
                      _c(
                        "h4",
                        { staticClass: "hidden-sm hidden-xs" },
                        [
                          _vm.multiple
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.dropMultipleFiles) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.dropSingleFile) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "h4",
                        { staticClass: "hidden-md hidden-lg" },
                        [
                          _vm.multiple
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.selectMultipleFiles) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.selectSingleFile) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                        ],
                        2
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.files, function(file, fileIndex) {
              return _c("tr", { key: fileIndex }, [
                _c("td", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "filename col-md-5" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\t" +
                          _vm._s(file.name) +
                          "\n\t\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-7" }, [
                      file.active || !file.success || file.progress !== "0.00"
                        ? _c("div", { staticClass: "progress" }, [
                            _c(
                              "div",
                              {
                                class: {
                                  "progress-bar": true,
                                  "progress-bar-striped": true,
                                  "progress-bar-danger":
                                    !file.active && !file.success,
                                  "progress-bar-animated": file.active
                                },
                                style: {
                                  width: file.success
                                    ? file.progress + "%"
                                    : "100%"
                                },
                                attrs: { role: "progressbar" }
                              },
                              [
                                file.success
                                  ? [_vm._v(_vm._s(file.progress) + "%")]
                                  : _vm._e(),
                                _vm._v(" "),
                                !file.success
                                  ? [
                                      _vm._v(
                                        _vm._s(_vm.getErrorMessage(file.error))
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(Math.floor(file.size / 1024)) + "kb")]),
                _vm._v(" "),
                _c("td", [
                  _c("i", {
                    staticClass: "fa fa-trash",
                    on: {
                      click: function($event) {
                        return _vm.removeFile(fileIndex)
                      }
                    }
                  })
                ])
              ])
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-md-6" },
        [
          _c(
            "label",
            {
              directives: [
                {
                  name: "id",
                  rawName: "v-id",
                  value: _vm.dropzoneID.length && _vm.inputId.length,
                  expression: "dropzoneID.length && inputId.length"
                }
              ],
              attrs: { for: "files" }
            },
            [
              _c(
                "file-upload",
                {
                  ref: "upload",
                  staticClass: "btn btn-default dropdown-toggle",
                  attrs: {
                    accept: _vm.accept,
                    value: _vm.files,
                    multiple: _vm.multiple,
                    size: _vm.size,
                    active: false,
                    drop: "#drop_" + _vm.inputId,
                    postAction: _vm.postAction,
                    headers: _vm.auth,
                    "input-id": _vm.inputId
                  },
                  on: { input: _vm.updateValue }
                },
                [
                  _c("i", {
                    staticClass: "fa fas fa-paperclip",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(" "),
                  _vm.multiple
                    ? [_vm._v(_vm._s(_vm.attachFiles))]
                    : [_vm._v(_vm._s(_vm.attachFile))]
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          !!_vm.URL.API_ORIGIN_URL
            ? _c("vue-friendly-iframe", {
                ref: "externalFileUploads",
                staticClass: "noBorder",
                class: {
                  thirdPartyFileUploader: _vm.resize,
                  maxHeight55: !_vm.resize
                },
                staticStyle: { width: "100%", border: "none" },
                attrs: {
                  src:
                    _vm.URL.API_ORIGIN_URL +
                    "?GOOGLE_API_CLIENT_ID=" +
                    _vm.URL.GOOGLE_API_CLIENT_ID +
                    "&GOOGLE_API_APP_ID=" +
                    _vm.URL.GOOGLE_API_APP_ID +
                    "&DROPBOX_API_CLIENT_ID=" +
                    _vm.URL.DROPBOX_API_CLIENT_ID +
                    "&ONEDRIVE_API_CLIENT_ID=" +
                    _vm.URL.ONEDRIVE_API_CLIENT_ID +
                    "&origin=" +
                    _vm.getOriginURL(),
                  allowfullscreen: "true"
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }